import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  padding: 8px 8px 80px 8px;
  overflow: auto;
  display: flex;
  gap: 2px;
  flex-direction: column;
`;

export const FooterWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 24px;
  border-top: 1px solid ${({ theme }) => theme.colors.black4};
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  justify-content: flex-start;
  border-radius: 0 0 8px 8px;
  align-items: flex-start;
  .ant-btn {
    font-weight: 400;
  }
`;
